import type { ReactNode } from 'react';
import type { TagTone } from '@/lib/status';
import s from './Tag.module.css';

/** 实底标签：一行只允许一个（给主状态），文档 18 §4.3 */
export function Tag({ tone = 'none', sm, children }: { tone?: TagTone; sm?: boolean; children: ReactNode }) {
  return <span className={[s.tag, s[tone], sm && s.sm].filter(Boolean).join(' ')}>{children}</span>;
}

/** 次级状态：6px 色点 + 文字 */
export function Dot({ tone, children }: { tone: 'green' | 'amber' | 'red' | 'grey' | 'blue'; children: ReactNode }) {
  return <span className={[s.dot, s[`d_${tone}`]].join(' ')}>{children}</span>;
}

/** 计数徽标：未闭环红、已闭环灰 */
export function Badge({ tone = 'red', children }: { tone?: 'red' | 'grey' | 'solid'; children: ReactNode }) {
  return <span className={[s.badge, s[`b_${tone}`]].join(' ')}>{children}</span>;
}
